/* --------------------------------------------------
Import modules
-------------------------------------------------- */

import SimpleSelector from 'simple-selector';

/* --------------------------------------------------
Selectors
-------------------------------------------------- */

// Create an object to store all the selectors
window.SimpleSelectors = {};
Watcher.observe('select', selects => {
  // Loop the selects
  selects.forEach(select => {
    // Find the label
    const label = document.querySelector(`label[for="${select.id}"]`);
    // Find the placeholder attribute
    const placeholderAttribute = select.getAttribute('placeholder');
    // Create a new SimpleSelector
    const Selector = new SimpleSelector(select, {
      placeholder: placeholderAttribute ? placeholderAttribute : label ? label.innerText : 'Select an option'
    });

    // Make the SimpleSelector available globally
    select.SimpleSelector = Selector;
    window.SimpleSelectors[select.id] = Selector;

    // Find the Selector placeholder
    const placeholder = Selector.template.placeholder;
    const wrapWordsInSpans = function () {
      let string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return string.split(' ').map(word => {
        return `<span>${word}</span>`;
      }).join(' ');
    };
    placeholder.innerHTML = wrapWordsInSpans(placeholder.innerHTML);
    Selector.on('update', () => {
      setTimeout(() => {
        console.log(placeholder.innerHTML);
        placeholder.innerHTML = wrapWordsInSpans(placeholder.innerHTML);
      }, 100);
    });
  });
});